import { render, staticRenderFns } from "./viplist.vue?vue&type=template&id=cd2d90ae&scoped=true&"
import script from "./viplist.vue?vue&type=script&lang=js&"
export * from "./viplist.vue?vue&type=script&lang=js&"
import style0 from "./viplist.vue?vue&type=style&index=0&id=cd2d90ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2d90ae",
  null
  
)

export default component.exports